<template>
  <div>
    <header-bar></header-bar>
    <!-- <div class="personalCTop">
            <div class="center">
                <div class="teacher_Banner">
                    <div class="teacher_Banner_Img">
                        <div class="teacher_Banner_Mask"></div>
                        <img :src="userInfo.avatar?userInfo.avatar:'../common/style/img/nan.jpg'" :alt="userInfo.name">
                    </div>
                    <div class="img"><img :src="userInfo.avatar?userInfo.avatar:'../common/style/img/nan.jpg'" :alt="userInfo.name"></div>
                    <div class="fl c-fff font14 font">
                        <p class="font26 mt10">{{userInfo.name}}</p>
                        <p class="mt10">{{userInfo.role}}</p>
                    </div>
                </div>
            </div>
        </div> -->
    <div class="layui-container mt20 mb20">
      <div class="layui-container fly-marginTop fly-user-main">
        <!-- <ul class="layui-nav layui-nav-tree layui-bg-white">
                    <li class="layui-nav-item"><a href="/#/User"><i class="layui-icon layui-icon-home"></i>个人主页</a></li>
                    <li class="layui-nav-item"><a href="/index/user/myfavourite.html"><i class="layui-icon layui-icon-star"></i>我的收藏</a></li>
                    <li class="layui-nav-item"><a href="/myorder.html"><i class="layui-icon layui-icon-form"></i>我的订单</a></li>
                    <li class="layui-nav-item"><a href="/myinfo.html"><i class="layui-icon layui-icon-set"></i>基本资料</a></li>
                    <li class="layui-nav-item"><a href="/binding.html"><i class="layui-icon layui-icon-video"></i>绑定手机</a></li>
                </ul> -->

        <div class="fly-panel fly-panel-user" pad20="" style="margin: 0;">
          <div class="layui-tab layui-tab-brief" lay-filter="user-btn">
            <div class="layui-tab-content layui-sign layui-clear" style="padding:20px 0;">
              <div class="fly-home"><img :src="userInfo.avatar?userInfo.avatar:'../common/style/img/nan.jpg'"
                  :alt="userInfo.name">
                <h1>{{userInfo.name}}</h1>
                <p class="fly-home-info">
                  <!-- <span>账户余额：<i class="layui-icon layui-icon-rmb" style="color:#ea4335;"></i><span style="color:#ea4335;">0</span></span> -->
                  <!-- <i class="ics cs-time"></i><span>2020-01-30 16:49:40 加入</span> -->
                </p>
                <hr>
                <ul class="layui-clear">
                  <li><a href="/#/Qikan"><i class="layui-icon layui-icon-set-sm"></i>
                      <p>期刊查询</p>
                    </a></li>
                  <li><a href="/#/User"><i class="layui-icon layui-icon-rmb"></i>
                      <p>我的主页</p>
                    </a></li>
                  <li><a @click="setPassword"><i class="layui-icon layui-icon-password"></i>
                      <p>修改密码</p>
                    </a></li>
                  <li><a @click="logout"><i class="layui-icon layui-icon-return"></i>
                      <p>退出登录</p>
                    </a></li>
                </ul>
                <!-- <blockquote class="layui-elem-quote">欢迎，您上次登录是在（2021-04-07 16:49:44），登录IP：（112.45.163.254），如非本人操作，请检查账号安全状态！</blockquote> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录注册框 -->
    <login :isLogin="isLogin" @loginVisible="loginVisible()" @loginSuccess="loginSuccess"></login>
    <password :isreset="isreset" @passwordVisible="passwordVisible()" @repassword="repassword"></password>
    <!--书籍样书-->
    <footerBar></footerBar>
  </div>
</template>
<script>
import headerBar from './header/Header'
import footerBar from './footer/Footer'
import $H from '../common/request.js'
import login from './login/Login'
import password from './login/Password'
export default {
  components: {
    headerBar,
    footerBar,
    login,
    password
  },
  data () {
    return {
      username: localStorage.getItem('userphone'),
      isLogin: false,
      hasLogin: false,
      isreset: false,
      user: null,
      userInfo: {}
    }
  },
  mounted () {
    let user = localStorage.getItem('loginUser')
    let loginTime = localStorage.getItem('loginTime')
    if (user) {
      user = JSON.parse(user)
      if (loginTime) {
        let time = Math.round(new Date().getTime() / 1000)
        if (time - Number(loginTime) > 86400) {
          this.hasLogin = false
        } else {
          if (user.access_token) {
            this.hasLogin = true
            this.user = user
            this.getUserInfo()
          }
        }
      }
    } else {
      this.isLogin = true
    }
  },
  methods: {
    loginSuccess () {
      this.isLogin = false
      this.hasLogin = true
      let user = localStorage.getItem('loginUser')
      let loginTime = localStorage.getItem('loginTime')
      if (user) {
        user = JSON.parse(user)
        if (loginTime) {
          let time = Math.round(new Date().getTime() / 1000)
          if (time - Number(loginTime) > 86400) {
            this.hasLogin = false
          } else {
            if (user.access_token) {
              this.hasLogin = true
            }
          }
        }
      }
      location.reload()
    },
    loginVisible () {
      this.isLogin = false
    },
    passwordVisible () {
      this.isreset = false
    },
    repassword () {
      this.isreset = false
      // 修改成功，退出登录
      localStorage.removeItem('loginUser')
      localStorage.removeItem('loginTime')
      localStorage.removeItem('userphone')
      location.reload()
    },
    logout () {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let header = {
          headers: {
            'Authorization': 'Bearer ' + this.user.access_token
          }
        }
        $H.post('/user/logout', {}, header).then(res => {
          console.log(res)
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
          localStorage.removeItem('loginUser')
          localStorage.removeItem('loginTime')
          localStorage.removeItem('userphone')
          // location.reload();
          this.$router.push('/')
        })
      }).catch((e) => {
        console.log(e)
        localStorage.removeItem('loginUser')
        localStorage.removeItem('loginTime')
        localStorage.removeItem('userphone')
        this.$router.push('/')
      })
    },
    setPassword () {
      this.isreset = true
    },
    getUserInfo () {
      let header = {
        'Authorization': 'Bearer ' + this.user.access_token
      }

      $H.get('/user/info', null, header).then(res => {
        console.log(res)
        this.userInfo = res
      })
    }
  }
}
</script>
<style scoped>
  @import '../common/style/layui.css';
  @import '../common/style/user.css';

  .mb20 {
    margin-bottom: 20px !important;
  }

  .mt20 {
    margin-top: 20px !important;
  }

  .fl {
    float: left;
  }

  .font14 {
    font-size: 14px !important;
  }

  .c-fff {
    color: #fff !important;
  }

  .font26 {
    font-size: 26px !important;
  }

  .mt10 {
    margin-top: 10px !important;
  }

  .personalCTop {
    width: 100%;
    height: 200px;
    margin-top: 70px;
  }

  .personalCTop .center {
    height: 100%;
  }

  .center {
    margin: 0px auto;
    overflow: hidden;
  }

  .teacher_Banner {
    height: 200px;
    overflow: hidden;
  }

  .teacher_Banner_Img {
    position: absolute;
    z-index: -1;
    overflow: hidden;
    height: 200px;
    width: 100%;
  }

  .teacher_Banner_Mask {
    width: 100%;
    height: 200px;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    z-index: 1;
  }

  .teacher_Banner_Img img {
    width: 110%;
    margin-left: -5%;
    margin-top: -2%;
    height: 120%;
    overflow: hidden;
    -webkit-filter: blur(60px);
    -moz-filter: blur(60px);
    -ms-filter: blur(60px);
    filter: blur(60px);
  }

  .personalCTop .img {
    float: left;
    width: 120px;
    height: 120px;
    border: 4px solid rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    overflow: hidden;
    margin-top: 35px;
    margin-left: 140px;
  }

  .personalCTop .img img {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }

  .personalCTop .font {
    margin: 40px 0 0 30px;
    width: 900px;
  }

  .layui-nav-item:hover {
    border-left: 3px solid #009688;
  }
</style>



// WEBPACK FOOTER //
// src/components/User.vue